export default __webpack_public_path__ + "static/CutoutLines-fae102d8e0218cdf5070f7b344fad81e.png";